{
  "en": "Englisch",
  "de": "Deutsch",
  "fr": "Französisch",
  "es": "Spanisch",
  "cs": "Tschechisch",
  "da": "Dänisch",
  "et": "Estnisch",
  "fi": "Finnisch",
  "hr": "Kroatisch",
  "hu": "Ungarisch",
  "it": "Italienisch",
  "lt": "Litauisch",
  "lv": "Lettisch",
  "nl": "Niederländisch",
  "nb": "Norwegisch Bokmål",
  "pl": "Polnisch",
  "pt": "Portugiesisch",
  "ro": "Rumänisch",
  "sk": "Slowakisch",
  "sl": "Slowenisch",
  "sq": "Albanisch",
  "sv": "Schwedisch"
}
